import React, { Component } from "react";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import deleteButton from '@images/close.svg';
import addButton from '@images/addrow_icon.svg';
import DropDownMenu from "@components/DropDownMenu";
import SessionStateManager from "@components/SessionStateManager";
import ValidationsManager from "@components/ValidationsManager";
import UpdateDialog from '@components/UpdateDialog';
import SupportAlert from "@components/SupportAlert";
import { CustomDialog, useDialog } from 'react-st-modal';
import styles from '../questionnaire.module.css';

class SICQuestion extends Component {
    state = {
        loading: true,
        sessionStateChanged: false,
        SICCodesValues: new Map(),
        SICCodesRows: [],
        SICCodesTotal: 0,
        rowFactIds: null,
        dropdownMenuItems: [],
    }

    async componentDidMount() {
        this.setState({ loading: true });

        let dropdownItems = [];

        this.props.questionState.question.questionDimensions.filter(dimension => dimension.canBeQuestionMeasureGroup == true)[0].questionDimensions.forEach(dimension => {
            dropdownItems.push({ key: dimension.name, value: dimension.description.trim() })
        });

        this.setState({ dropdownMenuItems: dropdownItems });

        this.setState({ loading: false });
    }

    CONFIG_DEFAULT_MINIMUM_ROWS = 3;
    CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD = 20;
    PERCENTAGE_FACT_ID = this.props.questionState.questionFactStates.sort((a, b) => (a.sequenceNumberY > b.sequenceNumberY) ? 1 : -1)[1].questionFactId;
    SIC_CODE_FACT_ID = this.props.questionState.questionFactStates.sort((a, b) => (a.sequenceNumberY > b.sequenceNumberY) ? 1 : -1)[0].questionFactId;

    sanitizeDecimalInput(value, previousValue) {
        if (value === undefined || value === null || value === '') return 0;
        let str = String(value);

        // Allow "0." or "100." mid-type — dot at end is a valid partial state
        const isPartialDecimal = str.endsWith('.');

        // Fix leading dot: ".23" → "0.23"
        if (str.startsWith('.')) str = '0' + str;

        // Fix leading zeros before a digit: "02.1" → "2.1"
        str = str.replace(/^0+(\d)/, '$1');

        // Validate: only digits with optional single dot and max 2 decimal places
        const pattern = /^\d{0,3}(\.\d{0,2})?$/;
        if (!pattern.test(str)) return previousValue;

        // Reject values above 100, but only when input is a complete number
        if (!isPartialDecimal && parseFloat(str) > 100) return previousValue;

        return str;
    }

    async handleOnChange(evt, questionFactId, ordinal, menuOptions) {
        let key = questionFactId + '_' + ordinal;
        let value = evt.target.value;

        if (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE') {
            const result = await CustomDialog(
                <UpdateAuditDialog
                    currentAnswer={SessionStateManager.getSessionValue(key)}
                    menuOptions={menuOptions}
                    numericInput={menuOptions == null}
                />,
                {
                    className: styles.updateAuditDialog,
                    title: 'Update Submitted Value',
                    showCloseIcon: false,
                    isFocusLock: true,
                    isCanClose: true, // setting this to false prevents the dialog from being closed when clicking away
                }
            );

            if (result !== undefined && result !== null && result.confirmed !== undefined && result.confirmed !== null && result.confirmed == true) {
                // Setting only the percentage questionFacts to zero when removed ie. nulled
                if (questionFactId === this.PERCENTAGE_FACT_ID) {
                    let newValue = ((result.newValue !== undefined && result.newValue !== null && result.newValue !== '') ? result.newValue : 0)
                    SessionStateManager.setSessionValueWithoutDependenciesValidation(key, newValue, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, result.sourceOfData, result.reason);
                } else {
                    SessionStateManager.setSessionValueWithoutDependenciesValidation(key, result.newValue, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, result.sourceOfData, result.reason);
                }
                this.setState({ sessionStateChanged: true });

            } else {
                evt.preventDefault();
            }
        } else {

            if (questionFactId === this.PERCENTAGE_FACT_ID) {
                value = this.sanitizeDecimalInput(value, SessionStateManager.getSessionValue(key));
            }
            SessionStateManager.setSessionValueWithoutDependenciesValidation(key, value, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");

            setTimeout(() => {
                for (let ord = 0; ord <= ordinal; ord++) {
                    let rowKey = questionFactId + '_' + ord;
                    if (!SessionStateManager.hasChangeListEntry(rowKey)) {
                        let rowValue = ((questionFactId !== this.PERCENTAGE_FACT_ID) ? SessionStateManager.getSessionValue(rowKey) : ((SessionStateManager.getSessionValue(rowKey) !== undefined && SessionStateManager.getSessionValue(rowKey) !== null && SessionStateManager.getSessionValue(rowKey) !== '') ? SessionStateManager.getSessionValue(rowKey) : 0));
                        rowValue = (rowValue !== undefined && rowValue !== null) ? rowValue : '';
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(rowKey, rowValue, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }
                }
            }, 0);

            this.setState({ sessionStateChanged: true });
        }
        if (this.props.onChange !== undefined && this.props.onChange !== null) {
            this.props.onChange(evt);
        }
    }

    handleOnBlur = (evt) => {
        if (this.props.onBlur !== undefined && this.props.onBlur !== null) {
            this.props.onBlur(evt);
        }
    }

    handleAddSICCodesRow = (evt, factIds) => {
        let rowsToAdd = parseInt(this.rowCountInput?.value || 1);
        if (rowsToAdd <= this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD) {

            rowsToAdd = ((rowsToAdd > this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD) ? (this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD) : rowsToAdd);
            const newRows = [];

            // If more rows are required, then lets always make sure that the default minimum rows are in the session state 
            for (let ordinal = 0; ordinal < this.CONFIG_DEFAULT_MINIMUM_ROWS; ordinal++) {
                factIds.forEach(factId => {
                    let thisKey = factId + '_' + ordinal;
                    if (!SessionStateManager.hasSessionValueByKey(thisKey)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, ((factId === this.PERCENTAGE_FACT_ID) ? 0 : ''), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }

                    if (SessionStateManager.hasSessionValueByKey(thisKey) && (SessionStateManager.getSessionValue(thisKey) === undefined || SessionStateManager.getSessionValue(thisKey) === null)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, ((factId === this.PERCENTAGE_FACT_ID) ? 0 : ''), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }

                });
            }

            for (let offset = 0; offset < rowsToAdd; offset++) {
                const item = {
                    ordinalEntry: parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.SICCodesRows.length + offset),
                    factIds: factIds
                };

                factIds.forEach(factId => {
                    let thisKey = factId + '_' + (this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.SICCodesRows.length + offset).toString(); //
                    if (!SessionStateManager.hasSessionValueByKey(thisKey)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, ((factId === this.PERCENTAGE_FACT_ID) ? 0 : ''), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }
                });

                newRows.push(item);
            }

            this.setState({
                SICCodesRows: [...this.state.SICCodesRows, ...newRows],
                sessionStateChanged: true
            });
        } else {
            evt.preventDefault();
        }
    };

    addSICCodesRow = (rowsToAdd, factIds) => {
        if (rowsToAdd > 0) {
            let newRows = [];
            for (let offset = 0; offset < rowsToAdd; offset++) {
                const item = {
                    ordinalEntry: parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.SICCodesRows.length + offset),
                    factIds: factIds
                };

                factIds.forEach(factId => {
                    let thisKey = factId + '_' + (this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.SICCodesRows.length + offset).toString(); //
                    if (!SessionStateManager.hasSessionValueByKey(thisKey)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, ((factId === this.PERCENTAGE_FACT_ID) ? 0 : ''), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }
                });

                newRows.push(item);
            }
            this.setState({
                SICCodesRows: [...this.state.SICCodesRows, ...newRows],
                sessionStateChanged: true
            });
        }
    };

    handleRemoveSICCodesRow = (evt) => {
        if (this.state.SICCodesRows.length > 0) {
            let rowToRemove = this.state.SICCodesRows.sort((a, b) => a.ordinalEntry > b.ordinalEntry ? 1 : -1)[this.state.SICCodesRows.length - 1];

            // Updating total by deleting all values for factIds of this row and re-calculating total
            rowToRemove?.factIds?.forEach(factId => {
                let thisKey = 'sic_' + rowToRemove.ordinalEntry + '_' + factId
                this.state.SICCodesValues.delete(thisKey);
            });

            let sum = parseFloat(0);
            this.state.SICCodesValues?.forEach((value, key) => {
                sum = sum + parseFloat(value)
            });
            this.setState({ SICCodesTotal: sum });

            rowToRemove?.factIds?.forEach(factId => {
                let thisKey = factId + '_' + rowToRemove.ordinalEntry;
                SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, ((factId === this.PERCENTAGE_FACT_ID) ? 0 : ''), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId);
                SessionStateManager.deleteSessionValue(thisKey);
            });
            this.setState({ sessionStateChanged: true });

            this.setState({
                SICCodesRows: this.state.SICCodesRows.sort((a, b) => a.ordinalEntry > b.ordinalEntry ? 1 : -1).slice(0, -1)
            });
        }
    };

    calculatePercentageTotal(valueFactId) {
        let sum = parseFloat(0);
        let sicCodes = SessionStateManager.allEntriesByQuestionFactId(valueFactId);

        sicCodes.forEach((item) => {
            sum = sum + parseFloat(item.value !== null && item.value !== '' && !isNaN(item.value) ? item.value : 0);
        });

        return sum.toFixed(2);
    }

    render() {
        if (this.state.loading === true) {
            return <p>Loading...</p>
        } else {

            let rowFactIds = [this.SIC_CODE_FACT_ID, this.PERCENTAGE_FACT_ID];
            if (this.state.rowFactIds == null) {
                this.setState({ rowFactIds: rowFactIds });
            }

            let initialRows = 0;

            let sicCodeCount = SessionStateManager.countEntriesByQuestionFactId(this.SIC_CODE_FACT_ID);
            initialRows = sicCodeCount > initialRows ? sicCodeCount : initialRows;

            let percentCount = SessionStateManager.countEntriesByQuestionFactId(this.PERCENTAGE_FACT_ID);
            initialRows = percentCount > initialRows ? percentCount : initialRows;

            let rowsToAdd = (this.CONFIG_DEFAULT_MINIMUM_ROWS < initialRows) ? (initialRows - this.CONFIG_DEFAULT_MINIMUM_ROWS - this.state.SICCodesRows.length) : 0;

            this.addSICCodesRow(rowsToAdd, rowFactIds);

            let defaultOrdinals = [];
            for (var ordinal = 0; ordinal < this.CONFIG_DEFAULT_MINIMUM_ROWS; ordinal++) {
                defaultOrdinals.push(ordinal);
            }

            return <div className={styles.SICQuestionContainer}>
                <table className="table">
                    <thead>
                        <tr>
                            <th width="5%">Row</th>
                            <th width="60%">SIC</th>
                            <th width="15%">Company Income Obtained (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {defaultOrdinals.sort().map(ordinal => (
                            <tr>
                                <td key={'sic_table_column_' + ordinal} className={styles.centerAlignVertically}>{ordinal + 1}</td>
                                <td
                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.SIC_CODE_FACT_ID + '_' + ordinal) ? styles.dropdownBoxUpdated : styles.centerAlignVertically}
                                >
                                    <DropDownMenu
                                        className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.SIC_CODE_FACT_ID + '_' + ordinal) ? styles.dropdownBoxUpdated : styles.dropdownBox}
                                        questionId={this.props.questionState.question.id}
                                        questionFactId={this.SIC_CODE_FACT_ID}
                                        ordinalEntry={ordinal}
                                        name={'sic_codes'}
                                        label={'SIC Code'}
                                        value={SessionStateManager.getSessionValue(this.SIC_CODE_FACT_ID + '_' + ordinal)}
                                        onChange={evt => this.handleOnChange(evt, this.SIC_CODE_FACT_ID, ordinal, this.state.dropdownMenuItems.sort((a, b) => a.key > b.key ? 1 : -1))}
                                        showKeys={true}
                                        menuOptions={this.state.dropdownMenuItems.sort((a, b) => a.key > b.key ? 1 : -1)}
                                        placeholder={'SIC Codes'}
                                        required
                                    />
                                </td>
                                <td
                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.PERCENTAGE_FACT_ID + '_' + ordinal) ? styles.tableInputBoxUpdated : null}
                                >
                                    <div className={styles.percentage}>
                                        <input
                                            className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.PERCENTAGE_FACT_ID + '_' + ordinal) ? styles.tableInputBoxUpdated : styles.tableInputBox}
                                            type="text"
                                            questionId={this.props.questionState.question.id}
                                            ordinalEntry={ordinal}
                                            questionFactId={this.PERCENTAGE_FACT_ID}
                                            placeholder='0.00'
                                            value={SessionStateManager.getSessionValue(this.PERCENTAGE_FACT_ID + '_' + ordinal)}
                                            onClick={(evt) => {
                                                if (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE') {
                                                    this.handleOnChange(evt, this.PERCENTAGE_FACT_ID, ordinal, null);
                                                }
                                            }}
                                            onChange={evt => {
                                                this.handleOnChange(evt, this.PERCENTAGE_FACT_ID, ordinal, null);
                                            }}
                                            onBlur={this.handleOnBlur}
                                        />
                                    </div>
                                </td>
                            </tr>)
                        )}

                        {this.state.SICCodesRows.map((item, idx) => (
                            <tr id="addr0" key={idx}>
                                <td key={'sic_table_column_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)} className={styles.centerAlignVertically}>{parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx) + 1}</td>
                                <td
                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.SIC_CODE_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)) ? styles.dropdownBoxUpdated : styles.centerAlignVertically}
                                >
                                    <DropDownMenu
                                        className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.SIC_CODE_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)) ? styles.dropdownBoxUpdated : styles.dropdownBox}
                                        questionId={this.props.questionState.question.id}
                                        questionFactId={this.SIC_CODE_FACT_ID}
                                        ordinalEntry={parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)}
                                        name={'sic_codes'}
                                        label={'SIC Code'}
                                        value={SessionStateManager.getSessionValue(this.SIC_CODE_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx))}
                                        onChange={evt => this.handleOnChange(evt, this.SIC_CODE_FACT_ID, parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx), this.state.dropdownMenuItems.sort((a, b) => a.key > b.key ? 1 : -1))}
                                        showKeys={true}
                                        menuOptions={this.state.dropdownMenuItems.sort((a, b) => a.key > b.key ? 1 : -1)}
                                        placeholder={'SIC Codes'}
                                        required
                                    />
                                </td>
                                <td
                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.PERCENTAGE_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)) ? styles.tableInputBoxUpdated : null}
                                >
                                    <div className={styles.percentage}>
                                        <input
                                            className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.PERCENTAGE_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)) ? styles.tableInputBoxUpdated : styles.tableInputBox}
                                            type="text"
                                            questionId={this.props.questionState.question.id}
                                            questionFactId={this.PERCENTAGE_FACT_ID}
                                            ordinalEntry={parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)}
                                            placeholder='0.00'
                                            value={SessionStateManager.getSessionValue(this.PERCENTAGE_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx))}
                                            onClick={(evt) => {
                                                if (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE') {
                                                    this.handleOnChange(evt, this.PERCENTAGE_FACT_ID, parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx), null);
                                                }
                                            }}
                                            onChange={evt => this.handleOnChange(evt, this.PERCENTAGE_FACT_ID, parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx), null)}
                                            onBlur={this.handleOnBlur}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td align='left' colSpan='2'>
                                <div>
                                    <span className={styles.cellHint}>
                                        <span className={styles.normalText}>
                                            <img
                                                src={addButton}
                                                alt="add row"
                                                onClick={(evt) => this.handleAddSICCodesRow(evt, rowFactIds)}
                                            />
                                            &nbsp;&nbsp; {'Add '}
                                            <input
                                                type="number"
                                                defaultValue="1"
                                                min="1"
                                                max={this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD}
                                                style={{ width: '60px', maxHeight: '20px', textAlign: 'center', border: '1px solid #ccc', borderRadius: '3px' }}
                                                ref={input => this.rowCountInput = input}
                                            /> additional rows
                                        </span>
                                        <span className={styles.tooltiptext}>
                                            {'A maximum of ' + this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD + ' additional rows may be added at one time.'}
                                        </span>
                                    </span>
                                </div>
                                <br />
                                <div>
                                    <span className={styles.cellHint}>
                                        <span className={styles.normalText}>
                                            <img
                                                src={deleteButton}
                                                alt="delete row"
                                                onClick={this.handleRemoveSICCodesRow}
                                            />
                                            &nbsp;&nbsp; {'Remove last row only.'}
                                        </span>
                                        <span className={styles.tooltiptext}>
                                            {'Clicking this button will remove the last row from the table.'}<br />
                                            {'Note: The first 3 rows will always remain visible, as this is the configured mininmum rows to display. Any rows that were previously created may also remain visible.'}
                                        </span>
                                    </span>
                                </div>
                            </td>
                            <td className={styles.noClickBox} >
                                <div>
                                    <TextField
                                        questionId={this.props.questionState.question.id}
                                        error={this.calculatePercentageTotal(this.PERCENTAGE_FACT_ID) != 100.00}
                                        helperText={this.calculatePercentageTotal(this.PERCENTAGE_FACT_ID) != 100.00 ? 'Total must sum to 100%' : null}
                                        type="number"
                                        id="outlined-error-helper-text"
                                        size="normal"
                                        value={this.calculatePercentageTotal(this.PERCENTAGE_FACT_ID)}
                                        ordinalEntry={0}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                            readOnly: true
                                        }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                cursor: 'not-allowed'
                                            },
                                            '& .MuiInputBase-input': {
                                                cursor: 'not-allowed',
                                                textAlign: 'right'
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                cursor: 'not-allowed'
                                            }
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        placeholder='0.00'
                                        readOnly
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        }
    }
}
export default SICQuestion;

function UpdateAuditDialog(props) {
    const dialog = useDialog();

    let componentRef = null;
    let result = {};
    result.confirmed = false;

    return (
        <div>
            <div
                className={styles.updateAuditDialogOverlay}
                ref={(response) => (componentRef = response)}
            >
                <UpdateDialog
                    {...props}
                    onChangeSourceOfData={(evt, newValue) => {
                        result.newValue = newValue;
                        result.sourceOfData = evt.target.value;
                    }}
                    onChangeReason={(evt, newValue) => {
                        result.newValue = newValue;
                        result.reason = evt.target.value
                    }}
                    onChangeNewValue={(evt) => {
                        result.newValue = evt.target.value
                    }}
                />
            </div>

            <div>
                <button
                    type="button"
                    className="btnBack"
                    onClick={(evt) => {
                        result.confirmed = false;
                        dialog.close(result);
                    }}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="btnNext"
                    onClick={(evt) => {
                        if (
                            result.sourceOfData === undefined || result.sourceOfData == null || result.sourceOfData.trim() == "" ||
                            result.reason === undefined || result.reason == null || result.reason.trim() == ""
                        ) {
                            SupportAlert.displayAlert('Required', 'Source of data and Reason are required fields.');
                        } else {
                            result.confirmed = true;
                            dialog.close(result);
                        }
                    }}
                >
                    Continue
                </button>
            </div>
        </div>
    );
}


